import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import CriarContrato from '../pages/financeiro/criarContrato';
import FaturarCliente from '../pages/financeiro/faturarCliente';
import AluguelMataraca from '../pages/gestaoEnergia/aluguelMataraca';
import CadastrarCC from '../pages/gestaoEnergia/cadastrarCC';
import CalcularAluguel from '../pages/gestaoEnergia/calcularAluguel';
import CartaTOI from '../pages/gestaoEnergia/cartaTOI';
import ContestacaoFaturas from '../pages/gestaoEnergia/contestacaoFaturas';
import DecryptPDF from '../pages/gestaoEnergia/decryptPDF';
import EmailTrocaTitularidade from '../pages/gestaoEnergia/emailTrocaTitularidade';
import ExcedentesUG from '../pages/gestaoEnergia/excedentesUG';
import FechamentoConsorcio from '../pages/gestaoEnergia/fechamentoConsorcio';
import InformarDebitos from '../pages/gestaoEnergia/informarDebitos';
import ListarCCsConsorcio from '../pages/gestaoEnergia/listarCCsConsorcio';
import SolicitarComprovante from '../pages/gestaoEnergia/solicitarComprovante';
import TrocaAgencia from '../pages/gestaoEnergia/trocaAgencia';

const RouteGE = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='GE'/>}>
                <Route path='calcularAluguel' element={<CalcularAluguel/>}/>
                <Route path='faturarCliente' element={<FaturarCliente/>}/>
                <Route path='cadastrarCC' element={<CadastrarCC/>}/>
                <Route path='listarCCsConsorcio' element={<ListarCCsConsorcio/>}/>
                <Route path='informarDebitos' element={<InformarDebitos/>}/>
                <Route path='criarContrato' element={<CriarContrato/>}/>
                <Route path='excedentesUG' element={<ExcedentesUG/>}/>
                <Route path='contestacaoFaturas' element={<ContestacaoFaturas/>}/>
                <Route path='emailTrocaTitularidade' element={<EmailTrocaTitularidade/>}/>
                <Route path='aluguelMataraca' element={<AluguelMataraca/>}/>
                <Route path='solicitarComprovante' element={<SolicitarComprovante/>}/>
                <Route path='trocaAgencia' element={<TrocaAgencia/>}/>
                <Route path='decryptPDF' element={<DecryptPDF/>}/>
                <Route path='cartaTOI' element={<CartaTOI/>}/>
                <Route path='fechamentoConsorcio' element={<FechamentoConsorcio/>}/>
            </Route>
        </Routes>
    );
};

export default RouteGE;
